import { FC } from "react";

import {
  GalleryTabData,
  GalleryTabOptions,
  SKUPageContentTabType,
} from "@/data/types";

import { CMSTab } from "./cms-tab";
import { CMSTabProvider } from "./cms-tab-context";
import { GalleryTabContent } from "./gallery-tab/gallery-tab-content";
import { GalleryTabProvider } from "./gallery-tab/gallery-tab-context";
import { GalleryTabHeader } from "./gallery-tab/gallery-tab-header";
import { GalleryTabSettings } from "./gallery-tab/gallery-tab-settings";

type Props = {
  index: number;
  options: GalleryTabOptions;
  data: GalleryTabData[];
};

export const CMSGalleryTab: FC<Props> = ({ index, options, data }) => (
  <CMSTabProvider tabType={SKUPageContentTabType.GALLERY_TAB} tabIndex={index}>
    <CMSTab options={options}>
      <GalleryTabProvider options={options} data={data}>
        <div className="space-y-6">
          <GalleryTabHeader />
          <GalleryTabContent />
          <GalleryTabSettings />
        </div>
      </GalleryTabProvider>
    </CMSTab>
  </CMSTabProvider>
);
